import React from "react";
import styled from "styled-components";
import InfoBlock from "./InfoBlock";
import InfoBlocksData from "../assets/content/InfoBlocksData";
import { connect } from "react-redux";
import ContactUs from "./ContactUs";
import "./LandingPage.css";
import { LargeDevice, Mobile } from "../components/ReactResponsiveComponents";
import axios from "axios";
import PromptBlock from "./PromptBlock";
import FocusAreas from "./FocusAreas";

import baseUrl from "../constants/baseUrl";
const url = baseUrl.services;


const LandingPageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;


const InfoBlockContainer = styled.div``;

class LandingPage extends React.Component {
  state = { isLoading: true, currentService: [], newsData:[], newsAreLoading: true };

  componentDidMount() {
   
    axios.get(`/services/cnc-landing-page`).then((res) => {
      const service = res.data;
      this.setState({ currentService: service[0] });
      this.setState({ isLoading: false });
    });
  }

  invertDirection(direction) {
    if (direction === "left") {
      return "right";
    } else {
      return "left";
    }
  }

  renderInfoBlocks(services) {
    let direction = "right";
    return services.map((service) => {
      direction = this.invertDirection(direction);
      const { title, description, includes, button } = service;
      const imageURL = url + service.imageName;
      return (
        <InfoBlock
          title={title}
          description={description}
          includes={includes}
          imageURL={imageURL}
          direction={direction}
          button={button}
          key={title}
        />
      );
    });
  }

  render() {
    const { title, description, includes, imageURL } = InfoBlocksData[0];

    return (
      <LandingPageContainer>
        <Mobile>
          <PromptBlock></PromptBlock>
        </Mobile>
        <LargeDevice>
         <PromptBlock></PromptBlock>
        </LargeDevice>
        
        {/* <LastestActivity /> */}
        <FocusAreas/>
        
        {!this.state.isLoading && (
          <>
            <InfoBlockContainer>
              {this.renderInfoBlocks(this.state.currentService.subservices)}
            </InfoBlockContainer>
            <ContactUs />
          </>
        )}
      </LandingPageContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return { section: state.section };
};

export default connect(
  mapStateToProps,
  {}
)(LandingPage);
